import { render } from "./GuideIOS.vue?vue&type=template&id=0a5d5dfa&scoped=true"
import script from "./GuideIOS.vue?vue&type=script&lang=js"
export * from "./GuideIOS.vue?vue&type=script&lang=js"

import "./GuideIOS.vue?vue&type=style&index=0&id=0a5d5dfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5d5dfa"]])

export default __exports__